import { render, staticRenderFns } from "./DragAndDropSortList.vue?vue&type=template&id=7ba003b2"
import script from "./DragAndDropSortList.vue?vue&type=script&lang=js"
export * from "./DragAndDropSortList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports